import { QueryClient } from '@tanstack/react-query';

// Statuses that cannot succeed on retry (auth failures / gone resources).
// Retrying them just multiplies the error storm — e.g. every query on a device
// whose user was deleted used to fire 4× before settling.
const NO_RETRY_STATUSES = new Set([401, 403, 404]);

const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } })?.response?.status ??
  (error as { status?: number })?.status;

const retryUnlessDefinitive =
  (limit: number) =>
  (failureCount: number, error: unknown): boolean =>
    !NO_RETRY_STATUSES.has(statusOf(error) ?? 0) && failureCount < limit;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // 5 minutes
      retry: retryUnlessDefinitive(3),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: retryUnlessDefinitive(1),
    },
  },
});
